module.exports = __webpack_public_path__ + "static/media/ll-mobile-account.fc37be03.svg";